// extracted by mini-css-extract-plugin
export default {"box":"Page_box__pFLNa","button":"Page_button__vne7a","buttonDiv":"Page_buttonDiv__slS0P"};